
  export default {
    mounted() {
      this._played = false;
      this.el.addEventListener('loot-crate:open', () => {
        if (!this._played) this._openChest();
      });
    },
    _openChest() {
      this._played = true;
      const chest = this.el.querySelector('canvas');
      if (chest) chest.dispatchEvent(new CustomEvent('loot-crate:play'));

      // Reveal reward UI as the Rive chest's lid opens (~1.4s)
      setTimeout(() => {
        const rewardUI = this.el.querySelector('[data-lc-reward-ui]');
        if (rewardUI) {
          rewardUI.style.opacity = '1';
          rewardUI.style.transform = 'translateY(0)';
        }

        // Play final cheer sound
        window.dispatchEvent(new CustomEvent('zulti:play-final-cheer', { detail: { matches: 1 } }));
      }, 1400);

      // Notify server that animation is done so button becomes Close
      const target = this.el.dataset.animationDoneTarget;
      setTimeout(() => {
        if (target) {
          this.pushEventTo(target, 'loot_crate_animation_done', {});
        }
      }, 1700);
    }
  }
